// 两条图文组合共用 GPT-6 Astra，图片型号随组合一起选择，不使用 Datastart 的 -sp 型号。
export const ASTRAFLOW_ASTRA_MODELS = Object.freeze([
  {
    id: 'astraflow_openai_astra_flare',
    provider: 'ASTRAFLOW_OPENAI_ASTRA_FLARE',
    model: 'gpt-image-2.5-flare',
    label: 'GPT-6 + Flare_线路3',
    recommendation: 'GPT-6 Astra · 快速生图与编辑，适合日常创作、产品图和批量生成',
  },
  {
    id: 'astraflow_openai_astra_sunburst',
    provider: 'ASTRAFLOW_OPENAI_ASTRA_SUNBURST',
    model: 'gpt-image-2.5-sunburst',
    label: 'GPT-6 + Sunburst_线路3',
    recommendation: 'GPT-6 Astra · 精细编辑与制作级画面，生成耗时更长',
  },
]);

export const DEFAULT_ASTRA_PROVIDER = ASTRAFLOW_ASTRA_MODELS[0].id;

export const isLegacyAstraProvider = (provider) => {
  const id = String(provider || '').trim().toLowerCase();
  return id === 'astraflow_openai_astra' || id === 'gpt-6-astra';
};

export const normalizeAstraProviderId = (provider) => {
  const id = String(provider || '').trim().toLowerCase();
  return isLegacyAstraProvider(id)
    ? DEFAULT_ASTRA_PROVIDER
    : id;
};

export const isAstraCombinedProvider = (provider) => (
  ASTRAFLOW_ASTRA_MODELS.some(({ id }) => id === normalizeAstraProviderId(provider))
);
